import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "gameProgressBar" }
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = { key: 0 }

import { ref, computed, onMounted, onBeforeUnmount, PropType } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData } from '@/view/game/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePopup',
  props: {
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
},
  emits: ['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = __emit

const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}

const loadMoreGame = () => {
    emits('loadMoreGame')
}

const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any) => {
    let data = {
        id: ID,
        makerId: makerID
    }
    emits('goToPlayGame', data)
}

__expose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { class: "game_container" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          class: "right_container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.gameList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "6",
                    class: "game_item",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GameCard, {
                        gameImage: item.customIcon,
                        onClickGameCard: ($event: any) => (goToPlayGame(item.gameId, item.gameMakerId)),
                        gameTypeId: item.id,
                        gameIsFavorite: item.isFavorite
                      }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            (__props.dataSet?.gameList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "progress",
                        style: _normalizeStyle({ width: __props.dataSet?.gameList.length / __props.dataSet.gameCount < 1 ? __props.dataSet?.gameList.length * 100 / __props.dataSet.gameCount + '%' : '100%' })
                      }, null, 4),
                      _createElementVNode("div", {
                        class: "progress-end-dot",
                        style: _normalizeStyle({ left: `calc(${__props.dataSet?.gameList.length * 100 / __props.dataSet.gameCount}% - 6px)` })
                      }, null, 4)
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round(__props.dataSet?.gameList.length / __props.dataSet.gameCount * 100)) + "% ", 1)
                  ]),
                  (__props.dataSet.activeItem != 'fav')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (!__props.dataSet?.loading && __props.dataSet?.showLoadMore)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "load_more_btn",
                              onClick: loadMoreGame
                            }, _toDisplayString(_ctx.$t('common.loadMore')), 1))
                          : _createCommentVNode("", true),
                        (__props.dataSet?.loading)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "loading_btn",
                              onClick: loadMoreGame
                            }, [
                              _createVNode(_component_van_loading, { size: "20" }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.loading')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})